import React from 'react';

export const parseTooltipNewlines = (
	tooltipContent: string,
): React.ReactElement => {
	return tooltipContent.indexOf('\n') === -1 ? (
		<>{tooltipContent}</>
	) : (
		<>
			{tooltipContent.split('\n').map(tooltipPart => (
				<>
					{tooltipPart}
					<br />
				</>
			))}
		</>
	);
};
